/**
 * Shared styles for component link/unlink buttons used across
 * classification, time-frequency, skillset, title, content, and notes slot plugs.
 *
 * - Unlinked: hidden by default, shown on .task-row:hover.
 *   Semi-transparent primary background, opaque primary icon.
 * - Linked: always visible. Opaque primary background, white icon.
 */

/** Common sizing and hover-reveal behaviour shared by all unlinked puzzle buttons */
const hoverRevealSx = {
    p: 0.25,
    bgcolor: (theme) => theme.palette.primary.main + "22",
    color: "primary.main",
    "&:hover": {
        bgcolor: (theme) => theme.palette.primary.main + "44",
    },
    width: 20,
    height: 20,
    opacity: 0,
    transition: "opacity 0.2s ease-in-out",
    ".task-row:hover &": {
        opacity: 1,
    },
}

/** Position wrapper for the unlinked puzzle button (zero-width overlay) */
export const unlinkButtonPositionSx = {
    position: "relative",
    width: 0,
    height: 0,
    alignSelf: "flex-start",
}

/** Unlinked state for inline row fields (classification, duration, frequency, skillset) */
export const linkButtonSx = {
    ...hoverRevealSx,
    position: "absolute",
    top: 0,
    left: -10,
    zIndex: 1,
}

/** Unlinked state for block-level areas (content, notes) — no positioning */
export const blockLinkButtonSx = {
    ...hoverRevealSx,
}

/** Unlinked state for inline title — no positioning */
export const titleLinkButtonSx = {
    ...hoverRevealSx,
}

/** Linked state: opaque primary bg, white icon, always visible */
export const linkedButtonSx = {
    p: 0.25,
    bgcolor: "primary.main",
    color: "primary.contrastText",
    "&:hover": { bgcolor: "primary.dark" },
    width: 20,
    height: 20,
}
